import { AgentCodeWriteBadge } from '@/components/chat/MessageComposer/AgentBadges/AgentCodeWriteBadge';
import { AgentInternetAccessBadge } from '@/components/chat/MessageComposer/AgentBadges/AgentInternetAccessBadge';
import { AgentRlsBadge } from '@/components/chat/MessageComposer/AgentBadges/AgentRlsBadge';
import { Skeleton } from '@/components/ui/skeleton';

interface AgentToolsCellProps {
    loading: boolean;
    hasInternetAccess: boolean;
    hasCodeWriteAccess: boolean;
    enableRls?: boolean | null;
}

export function AgentToolsCell({
    loading,
    hasInternetAccess,
    hasCodeWriteAccess,
    enableRls
}: AgentToolsCellProps) {
    if (loading) return <Skeleton className="rounded-full w-28 h-7" />;

    if (!hasInternetAccess && !hasCodeWriteAccess && !enableRls)
        return (
            <span className="text-muted-foreground text-xs leading-7">
                None
            </span>
        );

    return (
        <div className="flex flex-wrap gap-1.5">
            <AgentInternetAccessBadge hasInternetAccess={hasInternetAccess} />
            <AgentCodeWriteBadge hasCodeWriteAccess={hasCodeWriteAccess} />
            <AgentRlsBadge hasRls={!!enableRls} />
        </div>
    );
}
